/* eslint-disable no-param-reassign */
import { DatasourceUpgradeStringFieldDiff } from '../../datasourceUpgrade.types';

const setFilterText = (
  filter: DatasourceUpgradeStringFieldDiff,
  name: string,
) => {
  if (filter.status === 'unchanged') {
    return;
  }

  filter.title = name;

  if (!filter.currentPresetValue && filter.upgradePresetValue) {
    filter.description = `${name} added`;
    return;
  }

  if (filter.currentPresetValue && !filter.upgradePresetValue) {
    filter.description = `${name} removed`;
    return;
  }

  filter.description = `${name} changed`;
};

export const setFiltersText = (
  upgradeState:
    | {
        filter: DatasourceUpgradeStringFieldDiff;
        postFilter: DatasourceUpgradeStringFieldDiff;
      }
    | undefined,
) => {
  if (!upgradeState) {
    return;
  }

  const { filter, postFilter } = upgradeState;

  setFilterText(filter, 'Pre-processing filter');
  setFilterText(postFilter, 'Post filter');
};
